import { ModelBase, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class FileGroupingExportFileSpecLookup extends ModelBase {

    public staticServiceProviderFileGroupingExportFileSpecId: number = 0;

    public staticServiceProviderFileGroupingId: number = 0;

    public staticServiceProviderGroupingName: string = "";

    public reportName: string = "";

    public staticExportFileSpecId: number = 0;

    public exportFileTypeConcatenated: string = "";

    public isExcluded: boolean = false;

    public reportSpecId: number = 0;
}